export default __webpack_public_path__ + "static/O0147-f79e03da05e164a80a303b3262c20453.png";